import { defineComponent as _defineComponent } from 'vue'
import {computed} from "vue";
import Icon from "../features/IconComponent.vue";
import {PermissionsService} from "@/services/permissions/permissions.service";
import {useRouter} from "vue-router";
import {SideBarIconType} from "@/services/permissions/sidebar.config";
import GovernanceIcon from "../commons/GovernanceIcon.vue";
import {toUpperCase} from "uri-js/dist/esnext/util";
import FaucetIcon from "@/components/commons/FaucetIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppSidebar',
  setup(__props, { expose: __expose }) {
  __expose();

const permissionsService = new PermissionsService();
const router = useRouter();
const menu = computed(() => {
  return permissionsService.createSideBar();
});


const selected = computed(()=> {
  return menu.value.findIndex(element => router.currentRoute.value.path.includes(element.href));
});


function showSidebar() {
  let sidebar = document.getElementsByClassName('sidebar')[0] as HTMLElement;
  sidebar.classList.remove('display-none');
  sidebar.classList.add('display-flex');
  let showSidebar = document.getElementsByClassName('open-sidebar')[0] as HTMLElement;
  showSidebar.classList.remove('display-flex');
  showSidebar.classList.add('display-none');
}

function hideSidebar() {
  let sidebar = document.getElementsByClassName('sidebar')[0] as HTMLElement;
  sidebar.classList.remove('display-flex');
  sidebar.classList.add('display-none');
  let showSidebar = document.getElementsByClassName('open-sidebar')[0] as HTMLElement;
  showSidebar.classList.remove('display-none');
  showSidebar.classList.add('display-flex');
}



const __returned__ = { permissionsService, router, menu, selected, showSidebar, hideSidebar, Icon, get SideBarIconType() { return SideBarIconType }, GovernanceIcon, get toUpperCase() { return toUpperCase }, FaucetIcon }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})